import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@askable/ui/core/button';
import { Card } from '@askable/ui/core/card';
import { IconLogo } from '@askable/ui/core/logo';
import { useNavigate } from 'src/lib/routing';
import { useConnectedClient } from 'context/ConnectedClientContext';
import { teamUtils } from 'lib/teams';

export const TeamBlockedPage = () => {
  const { t } = useTranslation();
  const { t: tc } = useTranslation('components');
  const { details } = useConnectedClient();
  const navigate = useNavigate();

  const message = teamUtils.isAdminByRoleId(details?.teamRole)
    ? tc('teamEnforcement.blocked.admin')
    : tc('teamEnforcement.blocked.member');

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-muted p-4">
      <IconLogo className="absolute left-4 top-4 h-8" />
      <Card className="w-full max-w-sm items-center gap-3 px-6 py-6 text-center 2xl:py-6">
        <div className="flex size-10 items-center justify-center rounded-full bg-destructive/10">
          <CircleAlert className="size-6 fill-destructive text-background" aria-hidden />
        </div>
        <h1 className="text-lg font-semibold text-foreground">{tc('teamEnforcement.blocked.title')}</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <Button variant="outline" onClick={() => navigate('/logout', { replace: true })}>
          {t('global.signOut')}
        </Button>
      </Card>
    </div>
  );
};
